import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, RouterLink } from '@angular/router';
import { PlantDto } from '../../../plants/Models/plantDto.interface';
import { CommonModule, DatePipe } from '@angular/common';
import { TimestampDatePipe } from '../../../plants/shared/timestamp-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-plants-user',
    imports: [
        RouterLink,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatDividerModule,
        MatMenuModule,
        CommonModule,
        TimestampDatePipe,
        TranslatePipe
    ],
    standalone: true,
    templateUrl: './plants-user.component.html',
    styleUrl: './plants-user.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [DatePipe]
})
export class PlantsUserComponent {
    constructor(private router: Router) {}
    private _plants: PlantDto[] = [];

    @Input() set plants(v: PlantDto[] | null | undefined) {
        this._plants = v ?? [];
    }
    get plants() {
        return this._plants;
    }

    @Output() select = new EventEmitter<PlantDto>();
    onPick(p: PlantDto) {
        this.select.emit(p);
    }

    onView(plants: any) {
        const data = {
            id: plants.id
        };
        const queryParams: any = {};
        queryParams.plantId = data.id;
        this.router
            .navigate(['/plants/plants-detail', data.id], {
                queryParams: queryParams
            })
            .then(success => {
                if (!success) console.error('Navigation failed!');
            });
    }
}
